export default __webpack_public_path__ + "97aa47abfb8d42d056cdbc08381d4c0d.glb";